import {hideLoader, showLoader} from '../redux/action/loaderAction';
import {AppDispatch} from '../redux/rootReducer';

const login = (username: string, password: string, dispatch: AppDispatch) => {
    const url = window.environment.backend + 'login-api';
    const formData = new FormData();
    formData.append('username', username);
    formData.append('password', password);

    dispatch(showLoader());
    return fetch(url, {
        method: 'POST',
        mode: 'cors',
        credentials: 'include',
        body: formData
    }).finally(() => {
        dispatch(hideLoader());
    });
};

export default login;
